export const FOUNDERS_MAP = {
  "1 founder": 1,
  "2 founders": 2,
  "3 founders": 3,
  "More than 3": 3,
};
